import { render, staticRenderFns } from "./buscar.vue?vue&type=template&id=873e53fe&scoped=true"
import script from "./buscar.vue?vue&type=script&lang=js"
export * from "./buscar.vue?vue&type=script&lang=js"
import style0 from "./buscar.vue?vue&type=style&index=0&id=873e53fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873e53fe",
  null
  
)

export default component.exports